module.exports = __webpack_public_path__ + "static/media/icon-t4.1746a4d9.png";